import React, { useState, useEffect } from 'react';
import { Container, LayoutWrapper, MainWrapper } from '../layouts/style';
import Background from '../layouts/Background';
import HeaderSub from '../layouts/Header/sub';
import HeaderMain from '../layouts/Header/main';
import TopNotice from '../layouts/TopNotice';
import { useApp } from '../contexts/AppContext';

// isShowBannerPage = false: 띠배너가 있더라도 노출되지 않아야 하는 페이지
const Layout = ({
  children,
  isShowBannerPage = true, // 공통
  pageTitle, // 공통
  backIcon, // 서브
  homeIcon, // 서브
  menuIcon, // 서브
  closeIcon, // 서브
  onClickBackBtn, // 서브
  onlyLogo, // 메인
}) => {
  const { auth } = useApp();
  const [isShowBanner, setIsShowBanner] = useState(false);

  const renderHeader = () => {
    // 로고만 있는 헤더 선택 시 pageTitle === 'main' & onlyLogo={true}
    if (pageTitle === 'main') {
      return <HeaderMain showBanner={isShowBanner} onlyLogo={onlyLogo} />;
    }

    return (
      <HeaderSub
        showBanner={isShowBanner}
        pageTitle={pageTitle}
        backIcon={backIcon}
        closeIcon={closeIcon}
        menuIcon={menuIcon}
        homeIcon={homeIcon}
        onClickBackBtn={onClickBackBtn}
      />
    );
  };

  useEffect(() => {
    setIsShowBanner(auth.bannerMessage !== '' && isShowBannerPage);
  }, [auth.bannerMessage, isShowBannerPage]);

  return (
    <LayoutWrapper>
      <Background />
      <MainWrapper>
        {!!isShowBanner && (
          <TopNotice
            onClickClose={() => {
              setIsShowBanner(false);
            }}
            bannerMessage={auth.bannerMessage}
            bannerData={auth.bannerData}
          />
        )}
        {renderHeader()}
        <Container showBanner={isShowBanner}>{children}</Container>
      </MainWrapper>
    </LayoutWrapper>
  );
};

export default Layout;
